// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"590edb6ae73edaade525","655":"a8c809a1eee4422cb113"}[chunkId] + ".js";
};